<div class="modal-header pt-4 pb-3">
  <h5 *ngIf="!showAddContactForm" class="modal-title ">Mis direcciones</h5>
  <h5 *ngIf="showAddContactForm" class="modal-title ">Agregar destinatario</h5>
  <span class="font-weight-bold" (click)="modelService.dismiss()"><i class="fa fa-times"></i></span>
</div>
<div class="modal-body py-0 px-0 px-md-3 d-flex flex-column">
  <div id="address-info" class="bg-transparent m-2 p-2" [style.border-color]="'#0C8EFF'">
    <span [style.color]="'#0C8EFF'"><i class="fa fa-warning mr-2" ></i>Las fechas de entrega pueden variar según la ubicación y la disponibilidad
    </span>
  </div>
  <div *ngIf="!showAddContactForm; else add_contact">
    <section class="category position-relative contacts">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="product-box">
              <div class="cat-box d-flex justify-content-between mb-0 mb-md-2">
                <div class="" style="margin-right: 20px;width: 250px">
                  <label for="dropdown-location">Filtrar por ubicación</label>
                  <app-dropdown-treeview-select [includeParent]="true" id="dropdown-location" class="contact-list" [items]="locations"
                                                [(value)]="location" (valueChange)="onChange($event)">
                  </app-dropdown-treeview-select>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <span class="text-success p-2 cursor-pointer" (click)="contactToEdit = null; showAddContactForm = true" [ngbTooltip]="'Agregar contacto nuevo'"><i style="font-size: 24px"
                    class="fa fa-plus-circle p-1"></i></span>
                </div>
                <!--<div style="display: flex!important;padding-right: 25px;">
                  <div class="sortby" style="margin-right: 20px;">
                    <span>Sort by</span>
                    <select class="sort-box">
                      <option>Position</option>
                      <option>Name</option>
                      <option>Price</option>
                      <option>Rating</option>
                    </select>
                  </div>
                  <div class="show-item" style="margin-right: 20px;">
                    <span>Show</span>
                    <select class="show-box" #selectItems>
                      <option>10</option>
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>
                  <div class="page">
                    <p>Showing {{count$ | async}} / {{totalData$ | async}} results</p>
                  </div>

                </div>
-->
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 px-0 px-md-3">
            <div class="cart-table wsh-list table-responsive">
              <table class="table">
                <thead>
                <tr class="d-none d-md-table-row">
                  <th></th>
                  <th class="t-pro text-left">Contacto</th>
                  <th class="t-pro">Dirección de entrega</th>
                  <th class="t-price">Teléfono</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let contact of items$ |  async">
                  <tr class="position-relative" [class.no-selected]="!contact.isDefault" [class.selected]="contact.isDefault">
                    <td (click)="options(contact)" style="vertical-align: middle"><i *ngIf="contact.isDefault" class="fa fa-dot-circle-o" [class.text-success]="contact.isDefault"></i><i *ngIf="!contact.isDefault" class="fa fa-circle-o"></i></td>
                    <td class="t-pro" (click)="options(contact)">
                      <div class="t-content">
                        <p class="t-heading font-weight-bold mb-0">{{contact.firstName}} {{contact.lastName}} {{contact.secondLastName}}</p>
                        <ul class="list-unstyled col-sz">
                          <li><p class="mb-0">Carne de identidad: <span>{{contact.identity}}</span></p></li>
                          <li class="d-md-none"><p class="mb-0">Dirección: <span>{{formatAddress(contact.address, contact.town)}}</span></p></li>
                          <li class="d-md-none"><p class="mb-0">Teléfono: <span>{{contact.phone}}</span></p></li>
                        </ul>
                      </div>
                    </td>
                    <td (click)="options(contact)" class="t-price d-none d-md-table-cell">{{formatAddress(contact.address, contact.town)}}</td>
                    <td (click)="options(contact)" class="t-price d-none d-md-table-cell">{{contact.phone}}</td>
                    <td class="t-add">
                      <div class="top-bar2 pt-0">
                        <div class="top-left d-flex justify-content-center align-items-center">
                          <!--<span (click)="contactToEdit = contact; showAddContactForm = true" class="text-primary cursor-pointer p-1"><i class="fa fa-edit" title="Editar"></i></span>
                          <span (click)="removeContacts(contact)" class="text-danger cursor-pointer p-1"><i class="fa fa-trash" title="Eliminar"></i></span>-->
                          <div class="lang-box">
                            <span><i class="fa fa-cog"></i></span>
                            <ul class="dropdown list-unstyled">
                              <li *ngIf="!contact.isDefault" (click)="selectItem(contact)" class="text-left px-2"><span class="d-flex align-items-center"><i class="text-success fa fa-check-circle mr-2"></i>Seleccionar</span></li>
                              <li (click)="contactToEdit = contact; showAddContactForm = true" class="text-left px-2"><span class="d-flex align-items-center"><i class="text-primary fa fa-edit mr-2"></i>Editar</span></li>
                              <li (click)="removeContacts(contact)" class="text-left px-2"><span class="d-flex align-items-center"><i class="text-danger fa fa-trash-o mr-2"></i>Eliminar</span></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </td>
                    <ng-container *ngIf="showOptions == contact.code">
                      <ng-container *ngTemplateOutlet="snippet; context: { contact }">
                      </ng-container>
                    </ng-container>
                  </tr>
                </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </section>
    <section *ngIf="(items$ | async)?.length > 0" class="d-flex justify-content-center pb-4">
      <ngb-pagination [maxSize]="5" [pageSize]="pageSize$ | async" [collectionSize]="totalData$ | async"
                      (pageChange)="pageChange($event)" [page]="pageNo$ | async"></ngb-pagination>
    </section>
    <div *ngIf="(isLoading$ | async) || (selectUpdating$ | async)" class="backdrop" style="border-radius: 8px">
      <div class="text-center">
        <picture>
          <source srcset="assets/loading.webp" type="image/webp">
          <source srcset="assets/loading.gif" type="image/gif">
          <img style="height: 70px; width:70px" src="assets/imgs/loading.gif" alt="Cargando...">
        </picture>
      </div>
    </div>
  </div>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary bg-transparent text-secondary" data-dismiss="modal"
          (click)="modelService.dismiss()">Cerrar
  </button>
</div>
<ng-template #add_contact>
  <app-add-contact [location]="location" [contact]="contactToEdit" (showForm)="showForm($event)"></app-add-contact>
</ng-template>
<ng-template #snippet let-contact="contact">
  <div class="backdrop">
    <div class="snippet" data-title="options">
      <div class="stage">
        <div class="d-flex justify-content-center align-items-center flex-column">
          <button type="button" class="btn btn-success py-1 my-1" style="width:125px" data-dismiss="modal"
                  *ngIf="!contact.isDefault" (click)="showOptions = ''; selectItem(contact)">Seleccionar
          </button>
          <button type="button" class="btn btn-primary py-1 my-1" style="width:125px" data-dismiss="modal"
                  (click)="contactToEdit = contact; showOptions = ''; showAddContactForm = true">Editar
          </button>
          <button type="button" class="btn btn-danger py-1 my-1" style="width:125px" data-dismiss="modal"
                  (click)="showOptions = ''; removeContacts(contact)">Eliminar
          </button>
        </div>
      </div>
    </div>
    <span style="top: 2px; right: 10px; font-size: 18px" (click)="showOptions = ''" class="position-absolute font-weight-bold">&times;</span>
  </div>
</ng-template>
